import * as React from "react";
const SvgInclinedLeftRightArrow = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 1.41 14.71 6.7 18 10h-8V2l3.29 3.29L18.59 0 20 1.41ZM1.41 20l5.29-5.29L10 18v-8H2l3.29 3.29L0 18.59 1.41 20Z"
      fill="currentColor"
      fillOpacity={0.87}
    />
  </svg>
);
export default SvgInclinedLeftRightArrow;
